<template>
  <div class="account-act">
    <div class="account-act-header flex-cm">
      <img src="../assets/logo.jpg" style="width:40px;height:40px;margin-right:10px;"/>
      <div class="white-font font-size18">Fotoo授权管理</div>
    </div>
    <div class="account-act-body">
      <div class="black-font font-size16">点击下面按钮，开始关联账号</div>
      <div class="account-buttons white-font font-size14 flex-lm">
        <a class="account-wx-button account-button flex-cm white-font" :href="'https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid=wx9333ce473c826277&pre_auth_code='+authcode+'&redirect_uri=http://www.pfotoo.com'">
          <img  src="https://assets.pfotoo.com/pc/img/wx.svg" style="width:23px;margin-right: 5px;"/>
          <div>公众号授权(需管理员扫码)</div>
        </a>
        <!-- <div class="account-wb-button account-button flex-cm">微博头条文章授权</div> -->
      </div>
      <div class="account-info">
        <div class="account-info-title font-bold font-size14 black-font">1、公众号授权给Fotoo有什么用？</div>
        <div class="account-info-detail font-size14 black-font">可以将Fotoo收集的照片、视频等文件同步到公众号素材，方便推送使用</div>
        <div class="account-info-detail font-size14 black-font">可以将公众号后台的投稿收集到Fotoo，永久保存</div>
        <div class="account-info-detail font-size14 black-font">可以授权多个公众号同时管理</div>
        <div class="account-info-title font-bold font-size14 black-font">2、授权有什么风险吗？</div>
        <div class="account-info-detail font-size14 black-font">没有，Fotoo使用了微信平台提供的官方授权接口，是非常安全的</div>
        <div class="account-info-title font-bold font-size14 black-font">3、我的公众号已经授权给了其他的公众平台，怎么办？</div>
        <div class="account-info-detail font-size14 black-font">没问题，Fotoo的授权不会影响第三方平台的任何自定义菜单、开发模式、自定义回复等功能</div>
        <div class="account-info-title font-bold font-size14 black-font">4、如何取消给Fotoo的授权</div>
        <div class="account-info-detail font-size14 black-font">公众号的话，进入微信后台，选择设置/公众号设置，进入”授权管理“，就可以看到Fotoo的授权，并且可以解除授权了。</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'accounteg',
    data () {
      return {
        authcode:''
      }
    },
    methods:{
      getauthcode(){
       this.$http({
         url:'https://pfotoo.com?s=App.Open.Create_preauthcode'+this.$getsign(),
         params:{},
         method:'POST',
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         }
       }).then((res)=>{
         console.log(res.body)
         let json=res.body;
         if(res.body.ret==200){
            this.authcode=json.data;
         }
       })
      },
    },

    mounted(){
      this.getauthcode();
    },

  }
</script>

<style>
  .account-act{
    width:100%;
  }
  .account-act-header{
    width:100%;
    height:80px;
    background: #1A2E3B;
    margin-bottom: 40px;
  }
  .account-act-body{
    width:100%;
    padding-left:80px;
    box-sizing: border-box;
  }
  .account-buttons{
    padding-top: 20px;
  }
  .account-button{
    padding:0 10px;
    height:40px;
    border-radius:5px;
    margin-right:40px;
    cursor: pointer;
  }
  .account-wx-button{
    background: #0ABC64;
    text-decoration: none;
  }
  .account-wb-button{
    background:#353535
  }
  .account-info{
    width:100%;
    padding-top:40px;
  }
  .account-info-title{
    width:100%;
    padding-bottom:20px;
  }
  .account-info-detail{
    width:100%;
    padding-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/accounteg.vue